export default {
  gnb: {
    name: '리워드포인트',
    menu: {
      point: '포인트',
      withdrawInfo: '출금정보',
      faq: 'FAQ',
      pointHistory: '포인트 내역',
      pointExchangeHistory: '포인트 전환내역',
      userAuth: '본인확인정보',
    },
    login: '로그인',
    logout: '로그아웃',
  },
  fnb: {
    menu: {
      pointHistory: '포인트 내역',
      pointExchangeHistory: '포인트 전환내역',
    },
  },
  footer: {
    useOfTerms: '이용약관',
    userPolicy: '개인정보처리방침',
    operationPolicy: '운영정책',
  },
  common: {
    title: '보유포인트',
    pointRedemptionInfo: '포인트 전환 안내 사항',
    textExpire: '이번 달 소멸예정 금액',
    textExpireGlobal: '소멸예정 금액',
    textExpiryInSettlement: '이번 달 소멸예정 금액 - 정산 중',
    textLost: '{date} 소멸',
    textInfo: '포인트 전환 방법 알아보기',
    btnExchange: '전환신청',
    btnSearch: '조회',
    btnDesc: '상세내역',
    confirm: '확인',
    cancel: '취소',
    next: '다음',
  },
  date: {
    selectMonth: '기간선택',
    year: '년',
    month: '월',
    middle: ' ~ ',
  },
  // page - intro
  intro: {
    title: '리워드 포인트 서비스',
    desc: `현금으로 돌려받는 리워드<br>캐시백 되는 진짜 리워드`,
    title_list: '리워드 포인트',
    default_text: '서비스가 존재하지 않습니다.',
    initial_text: '로그인 후 리워드포인트 확인하세요.',
  },
  // page - 포인트 내역
  pointHistory: {
    statusList: ['적립', '사용', '취소'],
    earn: '넥슨 크리에이터즈 후원 적립',
    chargeCampaignPoint: '넥슨 크리에이터즈 캠페인 적립',
    rewardPoint: '리워드포인트 적립',
    chargeNConnectReward: 'N커넥트 리워드',
    cancelEarn: '넥슨 크리에이터즈 후원 적립 취소',
    chargeCampaignPointMinus: '넥슨 크리에이터즈 캠페인 적립 취소',
    lostPoint: '포인트 소멸',
    expiredPoint: '포인트 유효기간 만료',
    requestExchangePoint: '포인트 전환신청',
    withdrawPersonBalance: '개인 포인트 잔액 출금',
    cancelRequestExchangePoint: '포인트 전환신청({date} 신청) 지급취소',
    businessRegularProfit: '사업자 {year}년 {month}월 정기 수익',
    withdrawBusinessBalance: '사업자 잔액 출금',
    cancelBusinessRegularPayment: '사업자 {year}년 {month}월 정기 수익 지급취소',
    chargeLiveDonation: '포인트 지급',
    chargeLiveDonationMinus: '포인트 회수',
    pointsIssued: '포인트 지급',
    pointsReclaim: '포인트 회수',
    expiryDate: '유효기간',
    plus: '적립',
    minus: '사용',
    cancel: '취소',
    subContentExtra: {
      cancelChargeByRefund: '환불로 인한 적립 취소',
      withdrawCreator: '크리에이터 탈퇴',
      resetIdentifyVerification: '본인인증 초기화',
      failWithdrawal: '출금 실패',
      cancelGlobalExchangeRequest: '출금솔루션 거절',
      creatorSanction: '크리에이터 제재',
      policyViolation: '운영정책 위반',
      // pointTransferOperations: '포인트 지급',
      // pointTransferAccountHolderChange: '포인트 지급',
      pointTransferOperations: '운영으로 인한 이관 적립',
      pointTransferAccountHolderChange: '명의변경으로 인한 이관 적립',
    },
  },
  // page - 포인트 전환 내역
  exchangeHistory: {
    statusList: ['전체상태', '신청', '처리준비중', '지급취소', '처리중', '지급완료', '지급실패', '지급거절'], // krpc
    globalStatusList: ['전체상태', '신청', '진행중', '지급실패', '지급완료', '지급거절', '지급취소', '지급실패(오류)'], // global(krpc 외 계정)
    globalStatusRow: ['신청', '진행중', '지급완료', '지급취소', '지급거절', '지급실패', '지급실패(오류)'], // 포인트 전환 내역에 뜨는 상태
    caution: {
      title: '사업자 회원 유의 사항',
      content: `
        <li>사업자 회원은 전월 적립한 포인트에 대해 매월 1일 지급금액이 확정되어 포인트 전환 내역이 자동 생성됩니다.</li>
        <li>상세내역을 확인 후 확정된 금액에 대해서 전자세금계산서를 발행해주셔야 수익이 지급됩니다. </li>
        <li>전자세금계산서는 매월 25일까지 <a href="mailto:rewardpoint_tax@nexon.co.kr">rewardpoint_tax@nexon.co.kr</a> 로 보내주세요. </li>
        <li>세금계산서 미발행하신 경우 수익지급이 취소되거나 포인트가 소멸될 수 있습니다.</li>`,
      global: {
        title: '안내 사항',
        content: `
            <p>[현금]</p>
            <li>출금이 승인되면 익월 15일 입금처리 됩니다. 다만 해외 송금으로 인해 최대 7일이상 소요될 수 있습니다.</li>
            <li>출금 신청금액은 송금 수수료 등으로 인해 실제 수령액과는 차이가 있습니다.</li>
            <li>상세 내역 확인을 통해 좀 더 상세한 진행 상태를 확인 할 수 있습니다.</li>`,
        contentNexonPoint: `
            <p>[넥슨포인트]</p>
            <li>넥슨포인트 전환 신청은 신청한 달의 21일 이후 10영업일 이내에 순차적으로 크리에이터 활동을 하고 있는 계정에 충전 예정입니다.</li>
            <li>순차적 처리로 인해 넥슨포인트 지급 시점은 크리에이터 별로 상이할 수 있습니다.</li>`,
      },
    },
    requestExchangePoint: '포인트 전환신청',
    businessRegularProfit: '사업자 {year}년 {month}월 정기 수익',
    withdrawPersonBalance: '개인 포인트 잔액 출금',
    withdrawBusinessBalance: '사업자 잔액 출금',
    global: {
      table: {
        column: {
          regiDate: '신청일',
          status: '상태',
          withdrawPoint: '전환 신청 포인트',
          withdrawAmount: '전환 신청 금액',
          orderNo: '주문번호',
          type: '출금유형',
        },
      },
    },
  },
  // page - 출금 정보
  userInfo: {
    needVerifiedId:
      '본인 확인이 완료된 아이디만 이용이 가능합니다.<br/>내정보>내정보관리>개인정보변경에서 본인확인 후 이용해주세요.',
    removeWithdrawalInfo: '출금정보를 정말 삭제하시겠습니까 ?<br />입력한 출금 정보는 모두 삭제됩니다.',
    underReview: '아직 처리되지 않은 사업자 신청 내역이 있습니다.<br />처리 중에는 출금정보 삭제가 불가합니다.',
    processingCompleted: '처리가 완료되었습니다.',
  },
  // page - global
  global: {
    title: '포인트 출금 신청',
    titlePoint: '넥슨포인트 전환 신청',
    subTitle: '출금 신청',
    subTitlePoint: '전환 신청',
    mainText: `<span>포인트는 현금으로</span> 전환하여 출금 가능합니다.`,
    mainTextForNexonPoint: `<span>포인트는 현금으로 출금</span> 또는 넥슨포인트로 전환 가능합니다.`,
    subText: `<span>안내사항을 확인하시고, 출금 신청하기를 누르시면</span> 다음 단계로 이동합니다.`,
    applyGuide: '출금 신청 안내',
    applyGuidePoint: '넥슨포인트 전환 신청 안내',
    applyBtn: '출금 신청 하기',
    applyBtnPoint: '신청하기',
    detailButton: '상세 내역 확인',
    available: '보유 {pointName}',
    withdrawPointInput: '출금 신청 포인트 입력',
    withdrawNjPointInput: '전환 신청 포인트 입력',
    withdrawAmount: '출금 신청 금액',
    withdrawAmountPoint: '넥슨포인트 전환 신청 금액',
    transferFeeDescription: '송금 수수료 등으로 실제 수령 금액은 다를 수 있습니다.',
    transferFeeDescriptionPoint: '신청한 금액이 넥슨 포인트로 지급될 예정입니다.',
    confirmWithdrawCaution: '포인트 출금 유의사항을 모두 확인했습니다.',
    confirmWithdrawCautionPoint: '포인트 전환 유의사항을 모두 확인했습니다.',
    withdrawCaution: '출금 유의사항',
    pointCaution: 'NEXON 포인트 전환 관련 유의사항',
    maxAmount: '최대 가능 금액',
    inputPlaceholder: '{point}{unit}씩 입력가능',
    withdrawCautionDescriptions: {
      1: '1회 최소 {currency} {min} ~ {currency} {max} 까지 신청가능합니다.',
      2: '포인트 출금은 한번 신청 후 취소할 수 없습니다. ',
      3: '송금 수수료등을 제외하고 출금이 되므로 출금 신청금액과 수령금액은 다를 수 있습니다.',
      4: '포인트 획득에 부정행위가 있거나, 계좌 등의 신청정보에 문제가 있는 경우 출금 신청이 반려 될 수 있습니다.',
      5: '출금 신청 내역은 포인트 전환내역에서 확인할 수 있습니다. ',
      6: `
        <li>- 리워드 포인트의 수익화 절차(이하 "본 절차")에 있어서 고객이 제공하는 정보(개인 정보 포함, 이하 "제공정보")는<br />
          본 절차 및 고객에 대한 지원 절차에만 사용되며, 당사의
          <a
            href="https://company.nexon.co.jp/support/privacypolicy.html?_gl=1*1vcfzsa*_gcl_au*MTc5MzY4NDg5LjE3MDA4MDc3MzA"
            target="_blank"
          >개인정보 보호정책</a>에 따라 관리합니다.<br />
          제공된 정보는 당사가 수익화 절차를 위탁하는 Tipalti, Inc.(미국 캘리포니아주 소재)에 제공되며,<br />
          Tipalti, Inc.에서는 OECD 프라이버시 가이드라인 8원칙에 대응하는 조치를 취하고 있습니다.
        </li>
        <li>
          - 미국 캘리포니아주의 개인정보 보호 관련 제도에 관한 정보는 일본 개인정보보호위원회가 공표한
          <a href="https://www.ppc.go.jp/personalinfo/legal/kaiseihogohou/" target="_blank">문서</a>를 참고해 주시기 바랍니다.
        </li>
        <li>
          - 제공하신 정보는 정확하게 입력해주세요. 입력 내용의 불충분으로 인해 고객에게 발생하는 불이익에 대해 당사는 어떠한 책임도 지지 않음을 양해 부탁드립니다.
        </li>
      `,
    },
    withdrawPointCautionDescriptions: {
      1: '1회당 {min}{currency} ~ {max}{currency}까지 신청할 수 있습니다.',
      2: '신청 후 취소는 불가능합니다.',
      3: '포인트 적립 시 부정행위가 적발될 경우 출금 신청이 거부될 수 있습니다.',
      4: '신청 내역은 포인트 출금 내역에서 확인할 수 있습니다.',
    },
    modalHeader: '출금신청 방법 선택',
    modalTitle: `<span>출금신청 방법을</span> 선택해 주세요.`,
    modalDesc: `신청은 매 월 1회만 가능합니다.<br />신청방법은 신중하게 검토 후 선택하시기 바랍니다.`,
    cash: '현금',
    nexonPoint: '넥슨포인트',
    nextStep: {
      1: '다음 버튼을 클릭하면 출금을 위한 출금 정보 입력 단계로 넘어갑니다.',
      2: '입력해야할 출금 정보에 대한 가이드를 미리 확인 부탁드립니다.',
      3: '출금 정보 입력 가이드 보기',
    },
    nextStepForPoint: {
      1: `'신청하기' 버튼을 클릭하면 넥슨포인트 전환 신청이 완료됩니다.`,
      2: '전환 신청 시 유의사항은 아래 가이드에서도 확인하실 수 있습니다.',
      3: '신청 가이드',
    },
    withdrawFail: '진행중 오류가 발생했습니다.<br/>다시 시도해주세요.',
    withdrawSuccessTitle: '포인트 전환 신청을 요청하였습니다.',
    withdrawSuccessTitlePoint: '포인트 전환 신청이 완료되었습니다.',
    withdrawSuccessDesc:
      '신청 요청은 최대 30분 소요될 수 있으며,<br />포인트 전환내역에 진행 상황을 확인할 수 있습니다.',
    withdrawSuccessDescPoint:
      '넥슨포인트는 당월 21일 이후 승인을 거쳐 해당 계정으로 지급 예정입니다.<br />진행 상황은 포인트 전환내역에서 확인해주세요.',
    notAvailableCurrency: '죄송합니다.<br/>로그인 하신 계정은 이용할 수 없는 포인트입니다.',
    notAvailableAge: '죄송합니다.<br/> 출금신청은 만 14세 이상 계정만 이용 가능합니다.',
    notAvailablePeriod: '죄송합니다.<br/> 출금 신청 기간이 아닙니다<br/>출금 신청 기간을 확인하고 신청해주세요.',
    notAvailableEmail:
      '이메일 인증이 되지 않은 계정입니다.<br/>출금 신청은 이메일 인증된 계정만 이용가능합니다.<br/>넥슨 계정 설정 메뉴에서 이메일 인증을 진행해주세요.',
    notAvailableWithdrawCount: '죄송합니다.<br/>월 출금 신청횟수를 초과하여 출금신청을 할 수 없습니다.',
    notAvailableEnoughPoint: '죄송합니다.<br/>출금 신청할 수 있는 포인트 잔액이 부족합니다.',
    otpGuide: '보안을 위해 OTP 설정 후 개인정보 입력이 필요합니다.<br/>OTP설정을 하시겠습니까?',
    notFinishedReviewAuth: '등록하신 본인확인 정보가 아직 검토중입니다.<br/>처리가 완료된 후 다시 등록이 가능합니다.',
    notRegisteredAuth:
      '본인확인정보가 등록 되지 않았습니다.<br/>출금신청은 본인확인 정보 등록을 하고 등록된 정보에 대해 확인이 완료되면 출금 신청을 진행하실 수 있습니다.<br/>본인확인정보 등록을 하시겠습니까?',
    rejectedAuth:
      '등록하신 본인확인정보가 반려되었습니다.<br/>출금신청은 본인확인 정보 등록을 하고 등록된 정보에 대해 확인이 완료되면 출금 신청을 진행하실 수 있습니다.<br/>본인확인정보를 수정하시겠습니까?',
    reApplicationAuth:
      '등록하신 본인확인정보가 재신청요청 상태입니다.<br/>메일로 재신청요청 사유를 확인하신 뒤 본인확인정보 수정을 해주시기 바랍니다.<br/>본인확인정보를 수정하시겠습니까?',
    confirmingAuth:
      '현재 등록하신 본인확인 정보를 확인중입니다.<br/>본인 확인이 완료된 후 출금신청을 해주시기 바랍니다.',
    noneOtp: '보안을 위해 OTP 설정 후 출금신청이 가능합니다.<br/>OTP설정을 하시겠습니까?',
    validation: {
      minWithdrawPoint: '최소 {minValue}{unit} 이상부터 신청 가능합니다.',
      maxWithdrawPoint: '최대 {maxValue}{unit}까지 신청 가능합니다.',
      amountUnit: '{unitValue}{unit} 단위로 신청이 가능합니다.',
      notHasEnoughPoint: '보유하신 포인트보다 입력하신 포인트가 큽니다.',
      withdrawing: '잠시만 기다려주세요. 처리중인 신청내역이 있습니다.',
      notAvailableApplication:
        '죄송합니다.<br/>출금 신청이 불가능한 계정입니다.<br/>출금 신청 안내사항을 확인해주세요.',
      commonError: '죄송합니다.<br/> 알 수 없는 오류가 발생했습니다. 잠시 후 다시 시도해주세요',
    },
    exchangeRate: '환율 {unitValue}{unit} = {currency} 1',
    exchangePointRate: '환율 {unitValue}{unit} = 넥슨포인트 1{currency}',
  },
  error: {
    point: {
      1: '서비스 점검중으로 포인트 전환 신청을 할 수 없습니다.<br>점검 종료 후 다시 이용 부탁드립니다.',
      3001: '포인트 전환 신청은 본인 확인이 완료된 아이디만 이용이 가능합니다.<br>내정보>내정보관리>개인정보변경에서 본인확인 후 이용해주세요.',
      3002: '만 14세 미만 고객님께서는 포인트 전환 신청을 할 수 없습니다.',
      3004: '포인트의 잔액이 부족하여 전환 신청할 수 없습니다.',
      3005: '현금 캐시백은 월 1회 신청이 가능합니다.<br>이번 달에 이미 신청하신 내역이 있어 신청이 불가능합니다.<br>신청하신 내용은 포인트 전환 내역에서 확인해주세요.',
      3006: '포인트 잔액이 부족하여 전환 신청할 수 없습니다.',
      3008: '포인트 전환 신청은 사용자 정보와 수입 지급 계좌 정보를 등록 한 뒤 이용하실 수 있습니다.<br>지금 등록하시겠습니까?',
      3009: '사업자 사용자는 포인트 전환신청을 할 수 없습니다.<br> 사업자는 매월 1일 전월에 획득한 포인트에 대해 자동으로 전환신청이 되고 전자 세금계산서를 통해 수입을 지급받을 수 있습니다.',
      3013: '최소 {minValue}{unit} 이상부터 신청 가능합니다.',
      3015: '죄송합니다.<br/> 출금 신청 기간이 아닙니다<br/>출금 신청 기간을 확인하고 신청해주세요.',
      3017: '등록된 출금정보의 이름이 현재 회원정보와 일치하지 않습니다.<br>출금정보를 업데이트 해주세요.',
      default: '죄송합니다.<br>알 수 없는 오류로 포인트 전환 신청을 할 수 없습니다.<br>잠시 후 다시 이용해주세요.',
    },
    pointHistory: {
      0: '포인트 내역이 없습니다.',
      1: '서비스 점검중으로 포인트 내역을 확인할 수 없습니다.<br>점검 종료 후 다시 이용 부탁 드립니다.',
      default: '죄송합니다.<br>알 수 없는 오류로 내역을 불러올 수 없습니다. <br>잠시 후 다시 이용해주세요.',
    },
    exchangeHistory: {
      0: '포인트 전환 내역이 없습니다.',
      1: '서비스 점검중으로 포인트 전환 내역을 확인할 수 없습니다.<br>점검 종료 후 다시 이용 부탁 드립니다.',
      default: '죄송합니다.<br>알 수 없는 오류로 내역을 불러올 수 없습니다. <br>잠시 후 다시 이용해주세요.',
    },
    search: {
      day: '조회 기간은 최대 31일입니다.<br>날짜를 조정해주세요.',
      month: '조회 기간은 최대 12개월입니다.<br>날짜를 조정해주세요.',
    },
    common: {
      temporaryError: '일시적인 오류가 발생하였습니다.<br/>잠시 후 이용 부탁드립니다.',
      needLogin: '로그인 페이지로 이동 하시겠습니까?',
      needIdentity: '본인확인을 해주세요.',
      serviceNotAvailable: '서비스를 이용할 수 없습니다.',
      notPossiblePointConversion: '포인트 전환 신청을 할 수 없습니다.',
      retry: '다시 시도해 주세요.',
      serviceConnectionError: '서비스 연결이 원활하지 않습니다. 잠시 후 다시 시도해 주세요.',
      maintenance: '점검 중 입니다.',
      maintenanceDescription: '서비스 점검중입니다. 이용에 불편을 드려 죄송합니다.',
      errorPath: '잘못된 경로입니다.',
    },
    // 임시 에러 메시지
    temp: {
      global: '죄송합니다.<br>출금 신청이 불가능합니다.<br>출금 신청은 6월 중에 오픈될 예정입니다.',
    },
  },
};
